import { render, staticRenderFns } from "./AddTeamModal.vue?vue&type=template&id=5787900a&"
import script from "./AddTeamModal.vue?vue&type=script&lang=js&"
export * from "./AddTeamModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports